import list from "./authorize/list.js";
import form from "./authorize/form.js";
import doc from "./authorize/doc.js";
import ppwr from "./authorize/ppwr.js";
import options from "./authorize/options.js";
import gpsr from "./authorize/gpsr.js";
import guide from "./authorize/guide.js";

export default {
  authorizePages: {
    ...list,
    ...form,
    ...doc,
    ...ppwr,
    ...options,
    ...gpsr,
    ...guide,
  },
};
